// BaWChart.jsx
import React from 'react';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, BarElement, PointElement, CategoryScale, LinearScale } from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';

// Sample Data
const BaWChartData = [
  { day: 'Day 1', min: 110, max: 250 },
  { day: 'Day 2', min: 100, max: 145 },
  { day: 'Day 3', min: 105, max: 147 },
  { day: 'Day 4', min: 78, max: 149 },
  { day: 'Day 5', min: 111, max: 151 },
];

// Function to calculate box plot statistics
const calculateStatistics = (data) => {
  const values = data.flatMap(entry => [entry.min, entry.max]);

  // Helper function to calculate quartiles
  const getQuartiles = (arr) => {
    const sorted = arr.slice().sort((a, b) => a - b);
    const q1 = sorted[Math.floor((sorted.length / 4))];
    const q3 = sorted[Math.floor((sorted.length * (3 / 4)))];
    const median = sorted[Math.floor(sorted.length / 2)];
    return { q1, median, q3 };
  };

  const { q1, median, q3 } = getQuartiles(values);

  return {
    min: Math.min(...values),
    max: Math.max(...values),
    q1,
    median,
    q3
  };
};

const BaWChart = () => {
  const stats = calculateStatistics(BaWChartData);

  const data = {
    labels: ['Data'],
    datasets: [
      {
        label: 'Box Plot',
        data: [
          { x: 'Data', y: stats.q1 }, 
          { x: 'Data', y: stats.median }, 
          { x: 'Data', y: stats.q3 }  
        ],
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
        barPercentage: 0.5,
        categoryPercentage: 1,
        borderSkipped: 'bottom',
        type: 'bar',
        barThickness: 100,
        datalabels: {
          align: 'center',
          anchor: 'center',
          color: 'white',
          font: { size: 14 },
        }
      },
      {
        label: 'Upper Whisker',
        data: [
          { x: 'Data', y: stats.q3 },
          { x: 'Data', y: stats.max }
        ],
        borderColor: 'rgba(255, 0, 0, 1)',
        borderWidth: 4,
        type: 'line',
        borderDash: [5, 5], 
        pointRadius: 0
      },
      {
        label: 'Lower Whisker',
        data: [
          { x: 'Data', y: stats.q1 },
          { x: 'Data', y: stats.min }
        ],
        borderColor: 'rgba(255, 0, 0, 1)',
        borderWidth: 4,
        type: 'line',
        borderDash: [5, 5], 
        pointRadius: 0
      },
      {
        label: 'Median Line',
        data: [
          { x: 'Data', y: stats.median },
          { x: 'Data', y: stats.median }
        ],
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 2,
        type: 'line',
        pointRadius: 0
      }
    ],
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Category',
          color: 'white',
          font: { size: 16 }
        },
        ticks: {
          color: 'white', // X-axis ticks in white
          font: { size: 16 },
        },
      },
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: 'Value',
          color: 'white',
          font: { size: 16 }
        },
        ticks: {
          color: 'white', // Y-axis ticks in white
          font: { size: 16 },
        },
      }
    },
    plugins: {
      legend: {
        display: true,
        position: 'top'
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw.y}`;
          }
        }
      }
    }
  };

  return (
    <div className="w-full h-80">
      <Bar data={data} options={options} />
      {/* <Line data={data} options={options} /> */}
    </div>
  );
};

export default BaWChart;
